import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { injectStyles } from 'injectStyles';

import * as cssVariable from 'cssVariables';
import Favourite from 'components/svg/Favourite';

class EmptyStatePlaceholder extends PureComponent {
  static defaultProps = {
    title: 'Favorieten',
    subtitle: 'Nog niets opgeslagen',
    text: 'om op te slaan',
  };

  static propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string,
  };

  render() {
    const { classes, title, subtitle, text } = this.props;

    return (
      <div className={classes.emptyWrapper}>
        <h2 className={classes.title}>{title}</h2>
        <div className={classes.placeholder}>
          <h4 className={classes.subtitle}>{subtitle}</h4>
          <p className={classes.text}>
            Klik op
            <span className={classes.iconContainer}>
              <Favourite />
            </span>
            {text}
          </p>
        </div>
      </div>
    );
  }
}

const styles = {
  placeholder: {
    border: '2px dotted',
    borderColor: cssVariable.grey200,
    textAlign: 'center',
    padding: '60px 0',
    color: cssVariable.grey500,
    fontWeight: cssVariable.fontWeights.light,
  },
  emptyWrapper: {
    marginBottom: 40,
  },
  title: {
    marginTop: cssVariable.gutter * 2,
    marginBottom: 12,
    fontSize: cssVariable.fontSizes.medium,
    fontWeight: cssVariable.fontWeights.bold,
    textTransform: 'uppercase',
  },
  subtitle: {
    margin: 0,
    fontSize: `${cssVariable.fontSizes.small}px`,
    fontWeight: cssVariable.fontWeights.light,
  },
  text: {
    margin: 0,
  },
  iconContainer: {
    position: 'relative',
    padding: 3,
    '& > svg': {
      height: 15,
      width: 15,
    },
  },
};

export default injectStyles(styles)(EmptyStatePlaceholder);
